'use client'

interface AuthDividerProps {
  text?: string
}

export function AuthDivider({ text }: AuthDividerProps) {
  if (!text) {
    return <div className="border-t border-border" />
  }

  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t border-border" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-background px-2 text-muted-foreground">{text}</span>
      </div>
    </div>
  )
}
